import { combineReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import BillingPortalReducer from '../features/BillingPortal/BillingPortalSlice';
import AuthReducer from '../features/AuthSlice/AuthSlice';
import PaymentMethodUpdateReducer from '../features/PaymentMethodUpdate/PaymentMethodUpdateSlice';
import InvoicePaymentReducer from '../features/InvoicePayment/InvoicePaymentSlice';
import PreviewReducer from '../features/PreviewSlice/PreviewSlice';
export const rootReducer = combineReducers({
  auth: AuthReducer,
  billingPortal: BillingPortalReducer,
  paymentMethodUpdate: PaymentMethodUpdateReducer,
  invoicePayment: InvoicePaymentReducer,
  preview: PreviewReducer
});

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/usage/usage-with-typescript#define-typed-hooks
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;